import React from "react";
import AnimatedButton from "components/button/AnimatedButton";

const CurriculumHeader = ({ title, sectionTitle, buttonTitle, buttonLink }) => {
  return (
    <div className="flex xl:flex-row flex-col h-[300px] p-6 xl:p-[20px_100px] justify-between items-center bg-white rounded-[24px]">
      <div className="flex xl:w-[584px] flex-col items-start gap-[24px] shrink-0">
        <div className="flex pr-[10px] items-center">
          <h1 className="text-[#1E1E1E] font-noto-sans-armenian xl:text-[46px] font-black leading-normal">
            {title}
          </h1>
        </div>
        <div className="flex w-[200px] xl:w-[584px] h-[72px] flex-col justify-center items-center gap-[10px] bg-[#493ED3] rounded-[10px]">
          <h2 className="text-white font-noto-sans-armenian xl:text-[36px] font-black leading-normal">
            {sectionTitle}
          </h2>
        </div>
      </div>
      <AnimatedButton title={buttonTitle} link={buttonLink} />
    </div>
  );
};

export default CurriculumHeader;
